import './CategoryChips.scss';

export type CategoryChip = {
  id: number | string;
  name: string;
};

export type CategoryChipsProps<T extends CategoryChip['id']> = {
  items: Array<{ id: T; name: string }>;
  value: NoInfer<T> | null;
  onChange: (id: NoInfer<T> | null) => void;
  ariaLabel: string;
  clearLabel: string;
};

export function CategoryChips<T extends CategoryChip['id']>({
  items,
  value,
  onChange,
  ariaLabel,
  clearLabel,
}: CategoryChipsProps<T>) {
  if (items.length === 0) return null;

  return (
    <div className="app-category-chips" role="group" aria-label={ariaLabel}>
      {items.map((item) => (
        <button
          key={item.id}
          type="button"
          className={
            value === item.id
              ? 'app-category-chips__item app-category-chips__item--active'
              : 'app-category-chips__item'
          }
          aria-pressed={value === item.id}
          onClick={() => onChange(value === item.id ? null : item.id)}
        >
          {item.name}
        </button>
      ))}
      {value != null ? (
        <button
          type="button"
          className="app-category-chips__clear"
          onClick={() => onChange(null)}
        >
          {clearLabel}
        </button>
      ) : null}
    </div>
  );
}

export default CategoryChips;
